import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
//https://gv-backend-dev1.azurewebsites.net/api
const baseQuery = fetchBaseQuery({
  baseUrl: 'https://gv-backend-dev1.azurewebsites.net/api',
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions)
    if (process.env.NODE_ENV === 'development') {
      console.log(result)
    }
    if (result?.error?.status === 403) {
        if (process.env.NODE_ENV === 'development') {
          console.log('sending refresh token')
        }
        // send refresh token to get new access token 
        const refreshResult = await baseQuery('/auth/refresh', api, extraOptions)
        if (process.env.NODE_ENV === 'development') {
          console.log(refreshResult)
        }
        if (refreshResult?.data) {
          const currentUser = api.getState().auth.currentUser
          // store the new token (keep existing user fields)
          api.dispatch({ type: 'auth/setCredentials', payload: { ...currentUser, ...refreshResult.data } })
            // retry the original query with new access token 
            result = await baseQuery(args, api, extraOptions)
        } else {
            api.dispatch({ type: 'auth/logOut' })
        }
    }

    return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    tagTypes: [
      'Users',
      'User',
      'Plan',
      'Product',
      'Personal',
      'Partner',
      'Order',
      'Orders',
      'Event',
      'Blog',
      'Banner',
      'Address',
      'PublicJoinStatus',
    ],
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: builder => ({})
})